import store from 'config/store'
import { getRoughSizeOfObjectInBytes } from 'utils/metrics'

import { receiveServerResponseSize } from './actions'

export const stashLoadRequestResponseSize = (data: object) => {
  const hasLoaded = store.getState().view.initComplete

  if (!hasLoaded) {
    const sizeInBytes = getRoughSizeOfObjectInBytes(data)
    store.dispatch(receiveServerResponseSize({ size: sizeInBytes }))
  }
}
